import 'css.escape'

// Given an element, build a unique selector that can be used to later query the DOM
// to get the same element.
//
// Note that it can be gauranteed that the resulting selector will always match
// the given element. But it is not true that it will always only match the given
// element and no other element. It is possible that it can match other elements
// too. So the resulting selector should always be used as a "collection selector"
// like `document.querySelectorAll` instead of a "single item" selector like
// `document.querySelector`.
export function uniqueSelector(element: HTMLElement) {
  let node = element
  let selector = ''

  while (node !== null) {
    let currentSelector = node.tagName.toLowerCase()

    if (node.id) {
      currentSelector = `${currentSelector}#${CSS.escape(node.id)}`
    }

    if (node.className) {
      const classes = node.className
        .split(/\s/)
        .map((className) => CSS.escape(className))
        .join('.')
      currentSelector = `${currentSelector}.${classes}`
    }

    selector = selector.length > 0 ? `${currentSelector} > ${selector}` : currentSelector
    // @ts-expect-error TS(2322) FIXME: Type 'HTMLElement | null' is not assignable to typ... Remove this comment to see the full error message
    node = node.parentElement
  }

  return selector
}
